var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationServicesNew = function SvgNotificationServicesNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "#1b216b",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11a3 3 0 0 1 3-3h32a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.293 10.293a1 1 0 0 1 1.414 0L23 25.586l15.293-15.293a1 1 0 0 1 1.414 1.414L24.414 27a2 2 0 0 1-2.828 0L6.293 11.707a1 1 0 0 1 0-1.414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.503 21.951a1 1 0 0 1-.048 1.413L5.683 35.293a1 1 0 0 1-1.365-1.462L17.09 21.902a1 1 0 0 1 1.413.048zm8.988 0a1 1 0 0 0 .048 1.413l12.772 11.929a1 1 0 0 0 1.365-1.462L28.904 21.903a1 1 0 0 0-1.413.048M46 39a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3v-.272h2V39a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1h-.322v-2H43a3 3 0 0 1 3 3z"
  })));
};
export { SvgNotificationServicesNew as Icon };
export default __webpack_public_path__ + "static/media/e1dd0cee749bf7ae1a45a20cc49becca.svg";